import { app } from '@/bootloader';
import HealthCheckInstall from '@/modules/healthCheckService/index';
import { IHealthCheckProps } from '@/modules/healthCheckService/healthCheck.types';

app.use(HealthCheckInstall, {
  url:
    process.env.NODE_ENV === 'production'
      ? `${window.location.origin}/${process.env.VUE_APP_IB_MANAGER_HEALTH_CHECK_PATHNAME}`
      : `${process.env.VUE_APP_IB_MANAGER_PROTOCOL}//${process.env.VUE_APP_IB_MANAGER_HOSTNAME}:${process.env.VUE_APP_IB_MANAGER_PORT}/${process.env.VUE_APP_IB_MANAGER_HEALTH_CHECK_PATHNAME}`,
  interval: 5000,
} as IHealthCheckProps);
